import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

// Droits nécessaires : USER_PAYSLIP ou ADMIN_PAYSLIP
const GET_PAYSLIP = gql`
  query Payslip($uuid: ID!) {
    payslip(uuid: $uuid) {
      bonus
      comment
      createdAt
      currency
      employeeContributions
      employeeContributionsEur
      employerContributions
      employerContributionsEur
      grossSalary
      grossSalaryEur
      month
      netSalary
      netSalaryEur
      paymentDate
      payslipFileUuid
      taxes
      taxesEur
      uuid
      year
    }
  }
`;

export const usePayslip = () => {
  const [getPayslip, { loading, error, data, refetch }] = useLazyQuery(GET_PAYSLIP, {
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    data: data?.payslip,
    refetch,
    getPayslip: (uuid) => getPayslip({ variables: { uuid } }),
  };
};
